import FontAwesome from 'react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import ManagedResourceList from '../shared/ManagedResourceList';
import PageHeader from '../PageHeader';
import duckify from '../../utils/duckify';

import {entity as bulkFileWorkflows} from '../../ducks/bulkFileWorkflows';
import BulkFileWorkflowCreateModal from './BulkFileWorkflowCreateModal';

import dateFormat from '../../utils/dateFormat';

import './styles/bulkFileWorkflowsList.scss';

const hyphenate = (str) => str.replace(/[^a-z0-9]+/ig, '-');

const humanizeStatus = (workflow) => {
  switch (workflow.status) {
    case 'pending':
      return (
        <span>
          <FontAwesome name='spinner' spin />
          &nbsp;Pending
        </span>
      );
    case 'processing':
      return (
        <span>
          <FontAwesome name='spinner' spin />
          &nbsp;Processing Pages
        </span>
      );
    case 'ocr_matching':
      return (
        <span>
          <FontAwesome name='spinner' spin />
          &nbsp;Smart Matching
        </span>
      );
    case 'user_matching':
      return 'Awaiting Confirmation';
    case 'finished':
      return (
        <span>
          <FontAwesome name='check' />
          &nbsp;Finished
          {workflow.committed_by && <span> by {workflow.committed_by} on {dateFormat(workflow.committed_at)}</span>}
        </span>
      );
    case 'failed':
      return (
        <span>
          <FontAwesome name='warning' />
          &nbsp;Failed
        </span>
      );
    default:
      return workflow.status;
  }
};

class BulkFileWorkflowList extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      created_at: PropTypes.string,
      created_by: PropTypes.string,
      id: PropTypes.string,
      checklist_item: PropTypes.shape({
        name: PropTypes.string
      }),
      school_year: PropTypes.shape({
        name: PropTypes.string
      }),
      status: PropTypes.string
    }))
  };

  static defaultProps = {
    items: []
  };

  render() {
    const {items, deleteItem} = this.props;

    return (
      <div className="bulk-file-workflows-list">
        <PageHeader header="Bulk File Upload"/>

        {items.pending && <div><FontAwesome name="spinner" spin/> Loading...</div>}

        {items.ready &&
        <div>
          <ManagedResourceList
            fetchItems={() => Promise.resolve}
            items={items}
            displayType="Bulk File Upload"
            columns={[
                {header: 'Uploaded', value: item => dateFormat(item.created_at)},
                {header: 'Uploaded By', value: item => (item.created_by || '')},
                {header: 'Checklist Item Name', value: item => item.checklist_item ? item.checklist_item.name : ''},
                {header: 'Term', value: item => item.school_year ? item.school_year.name : ''},
                {header: 'Status', value: item => humanizeStatus(item)}
              ]}
            itemButtons={[
              ({item}) => item.status === 'user_matching' &&
                <Link className="bulk-workflows-list-action managed-list-item-action btn btn-xs btn-primary" to={`/setup/bulk_file_workflows/${item.id}`}>
                  <FontAwesome name="file"/>
                  &nbsp;Confirm Matches
                </Link>,
              ({item}) => item.status === 'finished' &&
                <Link className="bulk-workflows-list-action managed-list-item-action btn btn-xs btn-primary" to={`/setup/bulk_file_workflows/${item.id}`}>
                  <FontAwesome name="file"/>
                  &nbsp;Details
                </Link>,
              ({item}) =>
                <a target="_blank" href={`/api/bulk_file_workflows/${item.id}/download`} className="bulk-workflows-list-action btn btn-sm" data-bs-toggle="tooltip" title="Download Original Document">
                  <FontAwesome name="download"/>
                  &nbsp;Download
                </a>,
              ({item, deleteItem}) =>
                <button type="button" className="bulk-workflows-list-action managed-list-item-action btn btn-xs btn-danger" data-bs-toggle="tooltip" title="Delete" onClick={()=>deleteItem()}>
                  <FontAwesome name="trash"/>
                  &nbsp;Delete
                </button>
            ]}
            deleteItem={deleteItem}
            editModal={BulkFileWorkflowCreateModal}
            tableClassName="table-striped"
            rowClassName={item => `status-${hyphenate(item.status)}`}
            emptyListMessage=" "
          />
        </div>}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  items: ownProps.bulkFileWorkflows
});

const mapDispatchToProps = (dispatch) => ({
  deleteItem: (item) => dispatch(bulkFileWorkflows.actions.remove(item))
});

const mapDucksToProps = () => ({
  bulkFileWorkflows
});

export default duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(BulkFileWorkflowList);
